import { api } from '../contexts/ApiContext';

export async function getUserUiState(stateKey: string): Promise<Record<string, any> | null> {
  try {
    const res = await api.get(`/api/admin/user-ui-state/${encodeURIComponent(stateKey)}`);
    return res.data?.item?.value ?? null;
  } catch {
    return null;
  }
}

export async function putUserUiState(
  stateKey: string,
  value: Record<string, any>,
  sourceStorage: 'localStorage' | 'sessionStorage' | 'db' = 'db',
  legacySynced = false
): Promise<void> {
  try {
    await api.put(`/api/admin/user-ui-state/${encodeURIComponent(stateKey)}`, {
      value,
      source_storage: sourceStorage,
      legacy_synced: legacySynced,
    });
  } catch {
    // best-effort persistence only; caller already keeps local/session fallback
  }
}
